<script>
  import Header  from '/components/Header'
  import Lesson  from '/components/Lesson'
  import Main    from '/components/Main'
  import Picker  from '/components/Picker'
  import lessons from '/lib/lessons'
  import About   from '/pages/About'

  let lesson    = null
  let recording = null

  const handlePlay = event => {
    recording = {
      lesson: lesson.title,
      title : event.detail.title,
      hash  : event.detail.hash
    }
  }
</script>

<style lang="scss" global>
  @import "../styles/reset.scss";
  @import "../styles/global.scss";
</style>

<Header {recording} />
<Main>
  <Picker {lessons} bind:value={lesson} />
  {#if lesson}
    <Lesson {lesson} on:play={handlePlay} />
  {:else}
    <About />
  {/if}
</Main>
